export const personalData = [
  {
    name: "Isuru Dissanayake",
    designation: "Software Developer",
    linkedIn: "https://www.linkedin.com/in/isurudissanayakepage/",
    gitHub: "https://github.com/Isuru-Dissanayake"
  }
];
